import { promiseAction } from 'utils/store';

export const VIOLATION_ACTION_TYPES = {
  LOAD_VIOLATIONS: 'violation/LOAD_VIOLATIONS',
  DELETE_VIOLATION: 'violation/DELETE_VIOLATION',
};

export const loadViolations = promiseAction(VIOLATION_ACTION_TYPES.LOAD_VIOLATIONS);
export const deleteViolationAction = promiseAction(VIOLATION_ACTION_TYPES.DELETE_VIOLATION);

